import Svg from '@app/components/svg';

const EmptyTrashCan = Svg(
  <>
    <g clip-path="url(#a)">
      <g filter="url(#b)">
        <path
          fill="#E6EBED"
          d="m167.638 108.286-10.125 88.82c0 3.731-15.26 6.755-34.085 6.755-18.825 0-34.086-3.024-34.086-6.755l-9.746-88.447c2.846 2.649 21.385 4.693 43.832 4.693 23.488 0 42.698-2.239 44.125-5.066h.085Z"
        />
      </g>
      <ellipse
        cx="123.617"
        cy="108.051"
        fill="#99B0B7"
        rx="44.021"
        ry="5.414"
      />
      <path
        fill="#E6EBED"
        d="m164.708 56.963-.012-.02-.017-.03-.021-.035c-3.071-5.078-24.455-2.442-48.769 6.133-25.046 8.834-43.717 20.624-41.703 26.335.033.094.071.185.115.274l2.745 7.633.009.026.024.075c2.236 5.58 24.066 3.026 48.964-5.755 25.046-8.834 43.717-20.624 41.703-26.335a2.645 2.645 0 0 0-.316-.617l-2.451-6.953-.231-.657-.014-.026-.023-.042-.003-.006Z"
      />
      <ellipse
        cx="119.536"
        cy="73.352"
        fill="#F2F6F8"
        rx="48.088"
        ry="10.964"
        transform="rotate(-19.427 119.536 73.352)"
      />
      <path
        fill="#99B0B7"
        d="M50.166 112.26v1.812l2.93-.001-2.07 2.07 1.281 1.281 2.07-2.07v2.931h1.812v-2.931l2.07 2.069 1.282-1.282-2.07-2.069 2.932-.001v-1.812l-2.93.001 2.07-2.07-1.282-1.282-2.07 2.071v-2.932l-1.811.001v2.931l-2.07-2.069-1.282 1.282 2.07 2.069-2.932.001Zm2.96.014 1.26-1.26 1.783-.001 1.259 1.26v1.782l-1.26 1.26h-1.783l-1.259-1.259v-1.782ZM56.085 95.254l-1.282 1.282 2.098 2.099 1.282-1.282-2.098-2.099ZM61.224 100.394l-1.282 1.281 2.098 2.099 1.282-1.282-2.098-2.098ZM62.036 95.252l-2.1 2.1 1.281 1.281 2.1-2.1-1.281-1.28ZM56.893 100.395l-2.1 2.1 1.282 1.281 2.1-2.1-1.282-1.281ZM195.798 108.286h-1.813v2.968h1.813v-2.968ZM195.798 115.555h-1.813v2.967h1.813v-2.967ZM200.008 112.493h-2.97v1.812h2.97v-1.812ZM192.735 112.493h-2.969v1.812h2.969v-1.812ZM182.515 102.493v1.823l1.822-.001.001-1.823-1.823.001ZM178.326 106.71l-.001 1.822h1.822l.001-1.823-1.822.001ZM178.34 98.283l-.001 1.823h1.823l.001-1.823h-1.823ZM174.125 102.504l-.001 1.823h1.823l.001-1.823h-1.823ZM182.075 104.956l-1.289 1.29 1.289 1.288 1.289-1.289-1.289-1.289ZM176.139 104.973l-1.289 1.289 1.288 1.289 1.289-1.29-1.288-1.288ZM182.092 99.02l-1.289 1.289 1.288 1.289 1.29-1.289-1.289-1.289ZM176.141 99.022l-1.289 1.289 1.288 1.289 1.289-1.29-1.288-1.288ZM200.032 79.98l-.001 1.822h1.823l.001-1.823h-1.823ZM195.825 84.196l-.001 1.823h1.823l.001-1.823h-1.823ZM195.839 75.771l-.001 1.823h1.823l.001-1.823h-1.823ZM191.623 79.992v1.823h1.822l.001-1.823h-1.823Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path
          fill="#fff"
          d="M.5 0h250v250H.5z"
        />
      </clipPath>
      <filter
        id="b"
        width="136.042"
        height="143.574"
        x="55.596"
        y="84.286"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix values="0 0 0 0 0.00392157 0 0 0 0 0.227451 0 0 0 0 0.298039 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_807_993"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_807_993"
          result="shape"
        />
      </filter>
    </defs>
  </>,
  {
    viewBox: '27 0 203 204',
    fill: 'none',
  },
);

EmptyTrashCan.displayName = 'EmptyTrashCan';

export default EmptyTrashCan;
